module.exports = __webpack_public_path__ + "img/map4_empty.0ba288eb.png";